import React from 'react';
import { Box, Flex, Spinner } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function Button({
  variant = 'tertiary-1',
  size = 'medium',
  isLoading = false,
  type = 'button',
  children,
  ...rest
}) {
  let background;
  let textColor;
  let fontSize;
  let height;
  let border;
  let borderWidth = 0;
  let paddingX;
  let activeStyles;
  let hoverStyles;

  const focusStyles = {
    boxShadow:
      '0 0 1px 2px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .15)',
    outline: 0,
    textDecoration: variant.includes('tertiary') ? 'underline' : 'none',
  };
  const disabledStyles = {
    background: 'gray.300',
    color: 'gray.0',
    cursor: 'not-allowed',
  };

  if (size === 'large') {
    fontSize = 'md';
    height = '14';
    paddingX = `${(23.5 - borderWidth) / 16}rem`;
  } else if (size === 'medium') {
    fontSize = 'sm';
    height = '12';
    paddingX = `${(23.5 - borderWidth) / 16}rem`;
  } else if (size === 'small') {
    fontSize = 'xs';
    height = '10';
    paddingX = `${(19.5 - borderWidth) / 16}rem`;
  }

  if (variant.includes('tertiary')) {
    height = 'auto';
    paddingX = '0';
  }

  switch (variant) {
    case 'primary-1':
      // background = 'linear-gradient(135deg,#E9425B,#CF1F2E)';
      background = 'green.400';
      textColor = 'white';
      activeStyles = { background };
      hoverStyles = {
        // background: 'linear-gradient(135deg,#C31C35,#A90008)',
        background: 'green.500',
      };
      break;
    case 'primary-2':
      background = '#1B1B1B';
      textColor = 'white';
      activeStyles = { background };
      hoverStyles = {
        background: '#1B1B1BBF',
      };
      break;
    case 'secondary-1':
      background = 'transparent';
      // textColor = '#CF1F2E';
      // border = '2px solid #CF1F2E';
      textColor = '#48BB78';
      border = '2px solid #48BB78';
      activeStyles = { background };
      hoverStyles = {
        background: '#C6F6D5',
      };
      borderWidth = 2;
      break;
    case 'secondary-2':
      background = 'transparent';
      textColor = '#2E2E2E';
      border = '2px solid #1B1B1B';
      activeStyles = { background };
      hoverStyles = {
        background: '#1B1B1B1A',
      };
      borderWidth = 2;
      break;
    case 'tertiary-1':
      textColor = '#2E2E2E';
      hoverStyles = {
        textDecoration: 'underline',
      };
      break;
    case 'tertiary-2':
      textColor = '#EB003B';
      hoverStyles = {
        textDecoration: 'underline',
      };
      break;
    case 'tertiary-3':
      textColor = '#0475BC';
      hoverStyles = {
        textDecoration: 'underline',
      };
      break;
    default:
  }

  return (
    <Box
      as="button"
      type={type}
      paddingX={paddingX}
      fontSize={fontSize}
      height={height}
      borderRadius={variant.includes('tertiary') ? '0' : 'full'}
      border={border}
      background={background}
      color={textColor}
      fontWeight="bold"
      _hover={hoverStyles}
      _active={activeStyles}
      _focus={focusStyles}
      _disabled={disabledStyles}
      disabled={isLoading}
      position="relative"
      {...rest}
    >
      {isLoading && (
        <Box
          position="absolute"
          top="58%"
          left="50%"
          transform="translate(-50%,-50%)"
        >
          <Spinner emptyColor="gray.400" size="sm" />
        </Box>
      )}
      <Flex
        alignItems="center"
        justifyContent="center"
        visibility={isLoading ? 'hidden' : 'visible'}
      >
        {children}
      </Flex>
    </Box>
  );
}

Button.propTypes = {
  variant: PropTypes.oneOf([
    'primary-1',
    'primary-2',
    'secondary-1',
    'secondary-2',
    'tertiary-1',
    'tertiary-2',
    'tertiary-3',
  ]).isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  isLoading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Button;
